/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const EncounterStayType = {
    LongTerm: 'Long-Term',
    ShortTerm: 'Short-Term',
} as const;
export type EncounterStayType = typeof EncounterStayType[keyof typeof EncounterStayType];


export function instanceOfEncounterStayType(value: any): boolean {
    for (const key in EncounterStayType) {
        if (Object.prototype.hasOwnProperty.call(EncounterStayType, key)) {
            if (EncounterStayType[key as keyof typeof EncounterStayType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function EncounterStayTypeFromJSON(json: any): EncounterStayType {
    return EncounterStayTypeFromJSONTyped(json, false);
}

export function EncounterStayTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): EncounterStayType {
    return json as EncounterStayType;
}

export function EncounterStayTypeToJSON(value?: EncounterStayType | null): any {
    return value as any;
}

export function EncounterStayTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): EncounterStayType {
    return value as EncounterStayType;
}

